<template>
  <div>
    <el-dialog :title="niuNiuSettingData.title" :visible.sync="niuNiuSettingData.show" width="800px" center>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary">{{$t('Confirm')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    niuNiuSettingData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>